import { useState } from 'react';
import { Gallery, VideoSquare } from 'iconsax-react';
import { cn } from '@src/design-system/helpers';
import { isAnnouncementVideoMime } from '../utils/upload-announcement-media';

type AnnouncementMediaThumbnailProps = {
  file?: string | null;
  mimeType?: string | null;
  alt?: string;
  className?: string;
};

function isVideoMedia(mimeType?: string | null, file?: string | null) {
  if (mimeType && isAnnouncementVideoMime(mimeType)) return true;
  if (file && /\.(mp4|mov|webm)(\?.*)?$/i.test(file)) return true;
  return false;
}

export function AnnouncementMediaThumbnail({
  file,
  mimeType,
  alt = '',
  className,
}: AnnouncementMediaThumbnailProps) {
  const [hasError, setHasError] = useState(false);
  const isVideo = isVideoMedia(mimeType, file);

  if (isVideo) {
    return (
      <div
        className={cn(
          'flex size-10 shrink-0 items-center justify-center rounded-full bg-primary-100',
          className
        )}
      >
        <VideoSquare
          size={20}
          variant='Outline'
          className='text-gray-600'
        />
      </div>
    );
  }

  if (!file || hasError) {
    return (
      <div
        className={cn(
          'flex size-10 shrink-0 items-center justify-center rounded-full bg-primary-100',
          className
        )}
      >
        <Gallery
          size={16}
          variant='Outline'
          className='text-gray-500'
        />
      </div>
    );
  }

  return (
    <div
      className={cn(
        'size-10 shrink-0 overflow-hidden rounded-full bg-primary-100',
        className
      )}
    >
      <img
        src={file}
        alt={alt}
        className='size-full object-cover'
        onError={() => setHasError(true)}
      />
    </div>
  );
}
